import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/features/auth/auth.store'; // Import auth store
import authRoutes from '@/features/auth/auth.routes'; // Import auth routes
import dashboardRoutes from '@/features/dashboard/dashboard.routes'; // Import dashboard routes
import userManagementRoutes from '@/features/userManagement/userManagement.routes'; // Import user management routes
// import companyManagementRoutes from '@/features/companyManagement/companyManagement.routes'; // Import company management routes

const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...userManagementRoutes, // Add user management routes
  // ...companyManagementRoutes, // Add company management routes
  // Add other feature routes here as they are created
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Garde de navigation globale pour la gestion de l'authentification
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore(); // Access the store outside of setup()
  
  // Ensure auth status is up-to-date, especially on page refresh
  authStore.checkAuthStatus(); 

  const isAuthenticated = authStore.isAuthenticated;

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login'); // Rediriger vers la page de connexion si non authentifié et la route le requiert
  } else if (to.path === '/login' && isAuthenticated) {
    next('/'); // Rediriger vers le tableau de bord si déjà authentifié et tente d'accéder à la page de connexion
  } else {
    next(); // Continuer la navigation
  }
});

export default router;
